import { Badge, Checkbox, Input,  Select } from "antd";
import React, { useState } from "react";
import {  Button, Card, Col, Container, Form, FormGroup, Row, Modal} from "react-bootstrap";
import { Breadcrumb, ImageElement, LoginHeader} from "../../components";
import { Link, } from "react-router-dom"

function Profile() {

    const breadcrumb = [
        {
            path: '/dashboard',
            name: 'Home',
        },
        {
            path: '#',
            name: 'Profile',
        },
    ];
    const [profileEdit, setProfileEdit] = useState(false)

    const [showActive, setShowActive] = useState(false);
    const handleActiveClose = () => setShowActive(false);
    const handleActiveShow = () => setShowActive(true);
    const [showActiveCancel, setShowActiveCancel] = useState(false);
    const handleActiveCancelClose = () => setShowActiveCancel(false);
    const handleActiveCancelShow = () =>{
        setShowActiveCancel(true);
        setShowActive(false);
    } 

    const [showUpgrade, setShowUpgrade] = useState(false);
    const handleUpgradeClose = () => setShowUpgrade(false);
    const handleUpgradeShow = () => setShowUpgrade(true);



    return(
        <>            
            <LoginHeader/>         
            <div className="main-content profilePage">
                {/* page content */}
                <div className="pageContent">
                    <div className="pageContent_wide">
                        <Container>
                            <div className="d-flex justify-content-between">
                                <Breadcrumb title="Profile" breadcrumb={breadcrumb}/>
                                <Link to="/dashboard" className="btn btn-outline-info ms-3 mb-3 btn-sm">Back</Link>
                            </div>
                            {!profileEdit && 
                                <>
                                <div className="profileBox br-10 p-30 bg-white">
                                    <div className="d-flex align-items-center profileBox_info">
                                        <ImageElement source="profile-img.png" alt="user"/>
                                        <div className="ms-md-4 ms-2">
                                            <h2 className="font-md">Nikola Laringo</h2>
                                            <Badge className="text-500 ft-14" bg="primary">Member</Badge>
                                        </div>
                                        <div className="ms-auto">
                                            <span onClick={() => setProfileEdit(true)} className="editIcon"><em className="gg-edit"/></span>
                                        </div>
                                    </div>
                                    <div className="profileBox_card">
                                        <Row className="justify-content-center">
                                            <Col sm="6" md="4">
                                                <Card>
                                                    <Card.Body>
                                                        <em className="gg-message"/>
                                                        <Card.Title as="h3" className="font-bd text-uppercase">Email</Card.Title>
                                                        <Card.Text className="ft-14">nikolalaringo@gmail.com </Card.Text>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                            <Col sm="6" md="4">
                                                <Card>
                                                    <Card.Body>
                                                        <em className="gg-Calling"/>
                                                        <Card.Title as="h3" className="font-bd text-uppercase">Contact</Card.Title>
                                                        <Card.Text className="ft-14">+01  646-562-7924</Card.Text>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                            <Col sm="6" md="4">
                                                <Card>
                                                    <Card.Body>
                                                        <em className="gg-coupon"/>
                                                        <Card.Title as="h3" className="font-bd text-uppercase">Promo Code</Card.Title>
                                                        <Card.Text className="ft-14">Flat50</Card.Text>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                                <div className="membershipPlan br-10 p-30 bg-white">
                                    <h3 className="membershipPlan_heading font-md ft-14">Membership Plan</h3>
                                    <ul className="list-unstyled mb-0">
                                        <li className="membershipPlan_box" onClick={handleUpgradeShow}>
                                            <div className="d-flex flex-wrap align-items-center justify-content-between mb-1">
                                                <h6 className="mb-1 mb-sm-0 font-md ft-14 text-black ft-14 text-black">Free Trial Plan</h6>
                                                <span className="badge badge-upgrade">Upgrade</span>
                                            </div>
                                            <div className="d-flex align-items-center justify-content-between mb-1">
                                                <p>Monthly</p>
                                                <p>$20.00</p>
                                            </div>
                                            <div className="d-flex align-items-center justify-content-between">
                                                <p>Yearly</p>
                                                <p>$240.00</p>
                                            </div>
                                            <div className="d-flex align-items-center justify-content-between">
                                                <p className='text-black'>Save</p>
                                                <p className='text-black'>$5.00</p>
                                            </div>
                                        </li>
                                        <li className="membershipPlan_box active" onClick={handleActiveShow}>
                                            <div className="d-flex flex-wrap align-items-center justify-content-between mb-1">
                                                <h6 className="mb-1 mb-sm-0 font-md ft-14 text-black">Standard Plan</h6>
                                                <span className="badge badge-active">Active</span>
                                            </div>
                                            <div className="d-flex align-items-center justify-content-between mb-1">
                                                <p>Monthly</p>
                                                <p>$20.00</p>
                                            </div>
                                            <div className="d-flex align-items-center justify-content-between">
                                                <p>Yearly</p>
                                                <p>$240.00</p>
                                            </div>
                                            <div className="d-flex align-items-center justify-content-between">
                                                <p className='text-black'>Save</p>
                                                <p className='text-black'>10%</p>
                                            </div>
                                        </li>
                                        <li className="membershipPlan_box" onClick={handleUpgradeShow}>
                                            <div className="d-flex flex-wrap align-items-center justify-content-between mb-1">
                                                <h6 className="mb-1 mb-sm-0 font-md ft-14 text-black">Premium Plan</h6>
                                                <span className="badge badge-upgrade">Upgrade</span>
                                            </div>
                                            <div className="d-flex align-items-center justify-content-between mb-1">
                                                <p>Monthly</p>
                                                <p>$20.00</p>
                                            </div>
                                            <div className="d-flex align-items-center justify-content-between">
                                                <p>Yearly</p>
                                                <p>$240.00</p>
                                            </div>
                                            <div className="d-flex align-items-center justify-content-between">
                                                <p className='text-black'>Save</p>
                                                <p className='text-black'>$7.00</p>
                                            </div>
                                        </li>
                                        <li className="membershipPlan_box" onClick={handleUpgradeShow}>
                                            <div className="d-flex flex-wrap align-items-center justify-content-between mb-1">
                                                <h6 className="mb-1 mb-sm-0 font-md ft-14 text-black">Enterprice Plan</h6>
                                                <span className="badge badge-upgrade">Upgrade</span>
                                            </div>
                                            <div className="d-flex align-items-center justify-content-between mb-1">
                                                <p>Monthly</p>
                                                <p>$20.00</p>
                                            </div>
                                            <div className="d-flex align-items-center justify-content-between">
                                                <p>Yearly</p>
                                                <p>$240.00</p>
                                            </div>
                                            <div className="d-flex align-items-center justify-content-between">
                                                <p className='text-black'>Save</p>
                                                <p className='text-black'>$6.00</p>
                                            </div>
                                        </li>
                                        <li className="membershipPlan_box" onClick={handleUpgradeShow}>
                                            <div className="d-flex flex-wrap align-items-center justify-content-between mb-1">
                                                <h6 className="mb-1 mb-sm-0 font-md ft-14 text-black">Basic Plan</h6>
                                                <span className="badge badge-upgrade">Upgrade</span>
                                            </div>
                                            <div className="d-flex align-items-center justify-content-between mb-1">
                                                <p>Monthly</p>
                                                <p>$20.00</p>
                                            </div>
                                            <div className="d-flex align-items-center justify-content-between">
                                                <p>Yearly</p>
                                                <p>$240.00</p>
                                            </div>
                                            <div className="d-flex align-items-center justify-content-between">
                                                <p className='text-black'>Save</p>
                                                <p className='text-black'>$5.00</p>
                                            </div>
                                        </li>
                                        <li className="membershipPlan_box" onClick={handleUpgradeShow}>
                                            <div className="d-flex flex-wrap align-items-center justify-content-between mb-1">
                                                <h6 className="mb-1 mb-sm-0 font-md ft-14 text-black">10% Saving Plan </h6>
                                                <span className="badge badge-upgrade">Upgrade</span>
                                            </div>
                                            <div className="d-flex align-items-center justify-content-between mb-1">
                                                <p>Monthly</p>
                                                <p>$20.00</p>
                                            </div>
                                            <div className="d-flex align-items-center justify-content-between">
                                                <p>Yearly</p>
                                                <p>$240.00</p>
                                            </div>
                                            <div className="d-flex align-items-center justify-content-between">
                                                <p className='text-black'>Save</p>
                                                <p className='text-black'>$5.00</p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                </>
                            }
                            {profileEdit && 
                                <div className="profileBox br-10 p-30 bg-white">
                                    <div className="d-flex align-items-center profileBox_info">
                                        <div className="position-relative">
                                            <ImageElement source="profile-img.png" alt="user"/>
                                            <label className="upload position-absolute"><Input className="opacity-0 position-absolute" type="file" /><em className="text-500 gg-camera"/></label>
                                        </div>
                                    </div>
                                    <div className="profileBox_edit">
                                    <Form>
                                        <Row>
                                            <Col md={6}>
                                                <FormGroup className="form-group">
                                                    <label className="ant-label">First Name</label>
                                                    <Input size="large" placeholder="Enter First Name" value="Nikola"  />
                                                </FormGroup>
                                            </Col>
                                            <Col md={6}>
                                                <FormGroup className="form-group">
                                                    <label className="ant-label">Last Name</label>
                                                    <Input size="large" placeholder="Enter Last Name" value="Laringo" />
                                                </FormGroup>
                                            </Col>
                                            <Col md={6}>
                                                <FormGroup className="form-group">
                                                    <label className="ant-label">Email Address</label>
                                                    <Input size="large" placeholder="Enter Email Address" value="stevenhurd@gmail.com " />
                                                </FormGroup>
                                            </Col>
                                            <Col md={6}>
                                                {/* <FormGroup className="form-group">
                                                    <Input size="large" placeholder="Enter Mobile Number" value="+01  646-562-7924" />
                                                    <label className="ant-label">Mobile Number</label>
                                                </FormGroup> */}
                                                <FormGroup className="form-group form-group-number">
                                                <label className="ant-label">Mobile Number</label>
                                                <div className="position-relative">
                                                    <Input size="large" value="1234567890" placeholder="Number" />
                                                    <div className="form-cstm position-absolute top-0 left-0 d-flex">
                                                        <Select size="large" className="w-100" placeholder="+91"
                                                            options={[
                                                                {
                                                                    value: 'India',
                                                                    label: '+91',
                                                                },
                                                                {
                                                                    value: 'UK',
                                                                    label: '+1',
                                                                }
                                                            ]}
                                                        />
                                                    </div>
                                                </div>
                                            </FormGroup>
                                            </Col>
                                            <Col md={6}>
                                                <FormGroup className="form-group promoCode">
                                                    <div className="position-relative flex-grow-1">
                                                        <label className="ant-label">Applied Promo Code</label>
                                                    </div>
                                                    <div className="d-flex">
                                                        <Input size="large" placeholder="Enter Promo Code"  value="123456"/>
                                                        <Button variant="info" className="ms-auto">Apply</Button>
                                                    </div>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <div className="d-flex justify-content-end mt-2 mt-xl-3">
                                            {/* <Button variant="light" className="me-3 min-200" onClick={() => setProfileEdit(false)}>Cancel</Button> */}
                                            <Button variant="primary" className="min-200 btn-lg" onClick={() => setProfileEdit(false)}>Save</Button>
                                        </div>
                                    </Form> 
                                    </div>
                                </div>
                            }
                        </Container>
                    </div>
                </div>
            </div>
            {/* Active Modal */}
            <Modal show={showActive} onHide={handleActiveClose} centered id="membershipBasicPlan" className="membershipBasicPlan" backdrop="static">
                <Modal.Header closeButton>
                    <div>
                        <Modal.Title>Basic Plan</Modal.Title>
                        <p className="mb-0 mt-2"><b> Save - 10%</b></p>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <h6 className="font-md">Includes</h6>
                    <ul className="list-unstyled">
                        <li>Furnace Cleaning </li>
                        <li>A/C Cleaning  </li>
                        <li>Bonus Cleaning </li>
                        <li>Additional Saving Of 10% On Repairs </li>
                    </ul>
                    <div className="mb-3 mb-lg-4 mb-xxl-5">
                        <Checkbox checked>$14.99 Monthly </Checkbox>
                        <Checkbox>$14.99 Yearly </Checkbox>
                    </div>
                    <Button variant="light" className="min-200 ms-auto" onClick={handleActiveCancelShow}>CANCEL</Button>
                </Modal.Body>
            </Modal>
            <Modal show={showActiveCancel} onHide={handleActiveCancelClose} centered id="cancel" className="" backdrop="static">
                <Modal.Header closeButton className="align-items-start justify-content-center">
                    <div className="text-center">
                        <Modal.Title>Are you sure you want to cancel it?</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="d-flex align-items-center justify-content-center">
                         <Button variant="light" className="min-200" onClick={handleActiveCancelClose}>No</Button>
                         <Button variant="primary" className="min-200 ms-3" onClick={handleActiveCancelClose}>Yes</Button>
                    </div>
                </Modal.Body>
            </Modal>
            {/* upgrade Modal */}
            <Modal show={showUpgrade} onHide={handleUpgradeClose} centered id="membershipBasicPlan" className="membershipBasicPlan" backdrop="static">
                <Modal.Header closeButton>
                    <div>
                        <Modal.Title>Basic Plan</Modal.Title>
                        <p className="mb-0 mt-2"><b> Save - $5.00</b></p>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <h6 className="font-md">Includes</h6>
                    <ul className="list-unstyled">
                        <li>Furnace Cleaning </li>
                        <li>A/C Cleaning  </li>
                        <li>Bonus Cleaning </li>
                        <li>Additional Saving Of 10% On Repairs </li>
                    </ul>
                    <div className="mb-3 mb-lg-4 mb-xxl-5">
                        <Checkbox checked>$14.99 Monthly </Checkbox>
                        <Checkbox>$14.99 Yearly </Checkbox>
                    </div>
                    <div className="text-end">
                        <Link to="/membership-payment"   className="d-inline-flex btn btn-primary min-200 btn-lg">Pay Now</Link>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default Profile;